import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import MasterPage from "./pages/MasterPage";


import "./styles/App.css";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("❌ Ralat parsing user:", error);
        localStorage.removeItem("user");
      }
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (loggedInUser) => {
    setUser(loggedInUser);
  };

  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Login Route */}
        <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />

        {/* Dashboard Route (Protected) */}
        <Route
          path="/dashboard"
          element={
            user ? (
              <Dashboard
                userRole={user.role}
                userId={user.id}
                userDistrict={user.district}
                branchName={user.branchName}
              />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Default Route: Redirect to Dashboard if logged in, else Login */}
        <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
        <Route path="/master" element={<MasterPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
